import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=fb848612&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb848612",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb848612')) {
      api.createRecord('fb848612', component.options)
    } else {
      api.reload('fb848612', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=fb848612&scoped=true&", function () {
      api.rerender('fb848612', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-86KHDcCh95T0h/JS/comp/Voucher-Unit.vue"
export default component.exports